__turbopack_context__.v({
  "body": "EditContributionsForm-module-scss-module__8t-cPq__body",
  "deleteBtn": "EditContributionsForm-module-scss-module__8t-cPq__deleteBtn",
  "link": "EditContributionsForm-module-scss-module__8t-cPq__link",
  "row": "EditContributionsForm-module-scss-module__8t-cPq__row",
  "secondaryLabel": "EditContributionsForm-module-scss-module__8t-cPq__secondaryLabel",
});
